import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import parse from 'html-react-parser';
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import { logDoctorVisit, fetchDoctorsArticles, fetchDoctorsLMs, fetchDoctorsClinicalTrials } from "../../store/features/slice-doctors";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import Tabs from "../../components/Tabs";
import SingleInfo from "../../components/Dcotor/SingleInfo"
import SingleProfile from "../../components/Dcotor/SingleProfile"
import SingleLocations from "../../components/Dcotor/SingleLocations"
import SingleContact from "../../components/Dcotor/SingleContact"
import SingleRefer from "../../components/Dcotor/SingleRefer"



const DoctorDetails = (props) => {
    const [tabIndex, setTabIndex] = useState(() => {
        let tab = 0;
        if(props.location && props.location.state && props.location.state.prevPath){
            if(props.location.state.prevPath.indexOf("/discuss-patient") > -1){
                tab = 2
            }
        }
        return tab;
    });
    const dispatch = useDispatch();
    let { id } = useParams();
    const doctorDetailsSingle = useSelector((state) => state.doctors.full ? state.doctors.full[id] : null);
    const doctorEducationSingle = useSelector((state) => state.doctors.single);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    useEffect(() => {
        dispatch(setPageClass("page-doctor-single"));
        dispatch(setUpHeader({
          show: true,
          back: true,
          profile: true,
          search: true
        }));
    }, [dispatch]);

    useEffect(() => {
        if(isAuthenticated && doctorDetailsSingle){
            dispatch(logDoctorVisit({slug: doctorDetailsSingle.slug}))
        }
    }, [dispatch, isAuthenticated, doctorDetailsSingle]);

    useEffect(() => {
        if(doctorDetailsSingle && (!doctorEducationSingle.slug || doctorEducationSingle.slug !== doctorDetailsSingle.slug) ){
            dispatch(fetchDoctorsArticles({doctor: doctorDetailsSingle.slug, skip_loading: true}));
            dispatch(fetchDoctorsLMs({doctor: doctorDetailsSingle.slug, skip_loading: true}));
            dispatch(fetchDoctorsClinicalTrials({doctor: doctorDetailsSingle.slug, skip_loading: true}));
        }
    }, [dispatch, doctorDetailsSingle, doctorEducationSingle.slug]);

    
    const handleTabClick = (i) => {
        setTabIndex(i);
    }

    return (
        <>
            {doctorDetailsSingle ?
            <>
                <PageHead className="page-doctor-single--page-head" />
                <PageContent className="page-doctor-single--page-content">
                    <div className="page-doctor-single--aside">
                        <SingleInfo 
                            slug={doctorDetailsSingle.slug}
                            image={doctorDetailsSingle.profileImage && doctorDetailsSingle.profileImage.length > 0 ? doctorDetailsSingle.profileImage[0] : null}
                            title={parse(doctorDetailsSingle.salutation+' '+doctorDetailsSingle.name)}
                            postNominals={doctorDetailsSingle.postNominals}
                            tags={doctorDetailsSingle.tags}
                            classPrefix="page-doctor-single"
                        />
                    </div>
                    <div className="page-doctor-single--content">
                        <Section className="page-doctor-single--tabs">
                            <Tabs className="page-doctor-single--tabs-btns"
                                items={[
                                {
                                    index: 0,
                                    text: 'Profile', 
                                    Clicked:() => handleTabClick(0)
                                }, 
                                {
                                    index: 1,
                                    text: 'Location', 
                                    Clicked:() => handleTabClick(1)
                                },
                                {
                                    index: 2,
                                    text: 'Contact', 
                                    Clicked:() => handleTabClick(2)
                                },
                                {
                                    index: 3,
                                    text: 'Refer', 
                                    Clicked:() => handleTabClick(3)
                                }
                                ]}
                                activeItem={tabIndex}
                            />
                            <div className="page-doctor-single--tabs-content">
                                {tabIndex === 0 ? 
                                    <SingleProfile 
                                        slug={doctorDetailsSingle.slug}
                                        interests={doctorDetailsSingle.interests}
                                        interestsText={doctorDetailsSingle.interestsText}
                                        publications={doctorDetailsSingle.publications}
                                        bio={doctorDetailsSingle.bio}
                                        title={parse(doctorDetailsSingle.salutation+' '+doctorDetailsSingle.name)}
                                    />
                                : null}
                                {tabIndex === 1 ? 
                                    <SingleLocations 
                                        centres={doctorDetailsSingle.centres}
                                    />
                                : null}
                                {tabIndex === 2 ? 
                                    <SingleContact 
                                        slug={doctorDetailsSingle.slug}
                                        foxoId={doctorDetailsSingle.foxoId}
                                        linkedinUrl={doctorDetailsSingle.linkedinUrl}
                                        phone={doctorDetailsSingle.phone}
                                        phoneFormatted={doctorDetailsSingle.phoneFormatted}
                                        fax={doctorDetailsSingle.fax}
                                        email={doctorDetailsSingle.email}
                                        mobile={doctorDetailsSingle.mobile}
                                        mobileFormatted={doctorDetailsSingle.mobileFormatted}
                                    />
                                : null}
                                {tabIndex === 3 ? 
                                    <SingleRefer 
                                        slug={doctorDetailsSingle.slug}
                                        referralInfo={doctorDetailsSingle.referralInfo}
                                    />
                                : null}
                            </div>
                        </Section>
                    </div>
                </PageContent>
            </>
            : null}
         </>
    );
};

export default DoctorDetails;
